// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-json {
    font-family: "Segoe UI", Arial, sans-serif;
    background: #f7f9fb;
    color: #222;
    padding: 0;
    margin: 0;
}

.dashboard-json h2 {
    background: #0078d4;
    color: white;
    padding: 12px 20px;
}

.dashboard-json #dashboardContainer {
    display: flex;
    flex-direction: column;
    width: 100%;
}


.dashboard-json .region-top, .dashboard-json .region-bottom {
    padding: 10px 20px;
}

.dashboard-json .region-center {
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
    justify-content: center;
    padding: 10px 20px;
    transition: all 0.3s ease;
}

.dashboard-json .submodule {
    background: white;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    border-radius: 8px;
    padding: 12px;
    display: flex;
    flex: 1 1 45%;
    min-width: 400px;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.dashboard-json .submodule:hover {
    transform: scale(1.02);
    box-shadow: 0 4px 10px rgba(0,0,0,0.15);
}

.dashboard-json .submodule div {
    margin-right: 10px;
}

.dashboard-json .kpi {
    background: #eaf3ff;
    padding: 6px 10px;
    border-radius: 4px;
    font-weight: bold;
    margin-top: 10px;
    display: inline-block;
}

.dashboard-json table {
    border-collapse: collapse;
    width: 100%;
    margin-top: 10px;
}

.dashboard-json th, .dashboard-json td {
    border: 1px solid #ccc;
    padding: 6px 10px;
    text-align: left;
}

.dashboard-json button {
    background: #0078d4;
    color: white;
    border: none;
    padding: 8px 14px;
    border-radius: 4px;
    cursor: pointer;
    margin-right: 8px;
    transition: background 0.3s ease;
}

.dashboard-json button:hover {
    background: #005fa3;
}

.dashboard-json footer {
    text-align: center;
    color: #777;
    font-size: 12px;
    padding: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/dashboardJSON/components/dashboardData.css"],"names":[],"mappings":"AAAA;IACI,0CAA0C;IAC1C,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,qCAAqC;IACrC,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,qDAAqD;AACzD;;AAEA;IACI,sBAAsB;IACtB,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,aAAa;AACjB","sourcesContent":[".dashboard-json {\n    font-family: \"Segoe UI\", Arial, sans-serif;\n    background: #f7f9fb;\n    color: #222;\n    padding: 0;\n    margin: 0;\n}\n\n.dashboard-json h2 {\n    background: #0078d4;\n    color: white;\n    padding: 12px 20px;\n}\n\n.dashboard-json #dashboardContainer {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n}\n\n\n.dashboard-json .region-top, .dashboard-json .region-bottom {\n    padding: 10px 20px;\n}\n\n.dashboard-json .region-center {\n    display: flex;\n    gap: 15px;\n    flex-wrap: wrap;\n    justify-content: center;\n    padding: 10px 20px;\n    transition: all 0.3s ease;\n}\n\n.dashboard-json .submodule {\n    background: white;\n    box-shadow: 0 2px 5px rgba(0,0,0,0.1);\n    border-radius: 8px;\n    padding: 12px;\n    display: flex;\n    flex: 1 1 45%;\n    min-width: 400px;\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.dashboard-json .submodule:hover {\n    transform: scale(1.02);\n    box-shadow: 0 4px 10px rgba(0,0,0,0.15);\n}\n\n.dashboard-json .submodule div {\n    margin-right: 10px;\n}\n\n.dashboard-json .kpi {\n    background: #eaf3ff;\n    padding: 6px 10px;\n    border-radius: 4px;\n    font-weight: bold;\n    margin-top: 10px;\n    display: inline-block;\n}\n\n.dashboard-json table {\n    border-collapse: collapse;\n    width: 100%;\n    margin-top: 10px;\n}\n\n.dashboard-json th, .dashboard-json td {\n    border: 1px solid #ccc;\n    padding: 6px 10px;\n    text-align: left;\n}\n\n.dashboard-json button {\n    background: #0078d4;\n    color: white;\n    border: none;\n    padding: 8px 14px;\n    border-radius: 4px;\n    cursor: pointer;\n    margin-right: 8px;\n    transition: background 0.3s ease;\n}\n\n.dashboard-json button:hover {\n    background: #005fa3;\n}\n\n.dashboard-json footer {\n    text-align: center;\n    color: #777;\n    font-size: 12px;\n    padding: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
